// removed by extract-text-webpack-plugin
module.exports = {"Roles":"Roles--2kRbj","currentRoles":"currentRoles--2WjQE"};